function y(n) {
  return n == null ? void 0 : n.sort((r, s) => {
    var e, t;
    return ((e = r.order) != null ? e : 1 / 0) - ((t = s.order) != null ? t : 1 / 0);
  });
}
const h = (n) => {
  const r = Math.round(n / 60), s = Math.floor(r / 60), e = r - s * 60, t = s > 0 ? s + "h" : "", o = e > 0 ? e + "m" : "";
  return `${t} ${o}`.trim();
}, x = ({
  progress: n,
  duration: r
}) => {
  if (r)
    return Math.floor(n / r * 100);
}, m = (n, r = { parseUrls: !0, parseNewLines: !0 }) => {
  const s = /(https?:\/\/[^\s]+)/g;
  let e = [{ type: "text", content: n }];
  return r.parseUrls && (e = e.flatMap((t) => t.type === "text" ? t.content.split(s).map(
    (o) => s.test(o) ? { type: "link", content: o } : { type: "text", content: o }
  ) : t)), r.parseNewLines && (e = e.flatMap((t) => t.type === "text" ? t.content.split(`
`).flatMap(
    (o, f, i) => f < i.length - 1 ? [
      { type: "text", content: o },
      { type: "newline", content: "" }
    ] : [{ type: "text", content: o }]
  ) : [t])), e.filter((t) => t.type === "text" ? t.content.length > 0 : !0);
}, g = ({
  parsedText: n,
  isDescriptionExpanded: r,
  maxLength: s,
  render: e
}) => {
  const o = r ? n : ((i, p) => {
    let a = 0;
    const u = [];
    for (const c of i) {
      if (c.type === "text") {
        const l = p - a;
        if (c.content.length > l) {
          u.push({
            type: "text",
            content: c.content.slice(0, l)
          });
          break;
        }
        u.push(c), a += c.content.length;
      } else
        u.push(c);
      if (a >= p)
        break;
    }
    return u;
  })(n, s);
  return e(o);
};
export {
  x as c,
  h as f,
  m as p,
  y as s,
  g as u
};
//# sourceMappingURL=formatDescription-d621e46d.js.map
